import React from "react"
import { LoginForm } from "../components/forms/LoginForm"


export const Login = () => {
	return (
		<LoginForm/>
	)	
}